import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as _ from 'underscore';
import * as $ from 'jquery';
const compareObjects = require('fast-deep-equal');

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { ParameterField } from './ParameterField';
import { ThemeRenderer } from '../../../pdc-platform/src/tsx/ThemeRenderer';
import * as appTheme from '../ts/appTheme';
import TreeItemGeneral, { IToggleStates } from './TreeItemGeneral';

import ParameterFieldBase, { IParameterFieldBaseOptions } from '../ts/ParameterFieldBase';
import BooleanField from './BooleanField';

class WrappedList extends React.Component<any, any> {
    static defaultProps = {
        treshold: 5
    };

    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    expand = (e) => {
        this.setState({
            expanded: true
        });
    };

    containerClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    render() {
        let more;

        if (this.props.items.length > this.props.treshold && this.state.expanded !== true) {
            more = (
                <span key={'wrapped-list-more'} className="wrapped-list-more" onClick={this.expand}>
                    {'... and more (' + (this.props.items.length - this.props.treshold) + ')'}
                </span>
            );
        }

        let items = this.props.items;

        if (this.state.expanded !== true) {
            items = items.slice(0, this.props.treshold);
        }

        return (
            <div className="wrapped-list" onClick={this.containerClick}>
                {items}
                {more}
            </div>
        );
    }
}

class EditComponentDepsWrapper extends React.Component<
    {
        value;
        inheritedVariables: React.JSX.Element[];
        dependationVariables: React.JSX.Element[];
        selected: boolean;
        dependent: boolean;
        clearable?: boolean;
        showInheritedIcon?: boolean;

        //LL: 06.06.18: for Fields with array values, ex. color mapping
        ownValue?;
        parentValue?;

        finalTheme?: any; //LL: 19.09.19: try to access all Theme items in a Theme item

        widgetValues?: any; //LL: 15.03.20 to access Widget Props in Theme (when from WidgetBase)   NEW
        widgetTypeName?: string; //LL: 08.03.20: to access Widget Props in Theme     NEW

        hidden?: boolean; //LL: 06.09.19

        EditComponent: React.ComponentClass<{
            value;
            param;
            options;
            themeObj?: appTheme.IValuesCollection;
            glob: IGlob;

            onChange(): void;
        }>;

        param: ParameterFieldBase<IParameterFieldBaseOptions>;

        onChange(): void;
        onClear(): void;
        onHeaderClick(): void;

        glob: IGlob;
    },
    {}
> {
    render() {
        let deps;
        let inherited;

        if (this.props.dependationVariables != null && this.props.dependationVariables.length > 0) {
            deps = (
                <div key={'vars-list-deps'} className="vars-list">
                    <span>{'Is Dependent Upon:'}</span>

                    <WrappedList key={'wrapped-list-deps'} items={this.props.dependationVariables} />
                </div>
            );
        }

        if (this.props.inheritedVariables != null && this.props.inheritedVariables.length > 0) {
            inherited = (
                <div key="vars-list-inherited" className="vars-list">
                    <span>{'Change Will Affect:'}</span>

                    <WrappedList key="wrapped-list-inherited" items={this.props.inheritedVariables} />
                </div>
            );
        }

        //LL: 01.05.20: TRY, not used, but don't remove for a while !!  ==============================
        //LL: 06.09.19:  TRY to access Widget Props in Theme:  OLD  =================
        //    Leo asks to show for Charts only theme items that are actual for current Chart Type, i.e. differ XY,Pie,D3
        let widgetData; //LL: 01.05.20: not used

        const WidgetEditStore = this.props.glob.WidgetEditStore; //   pdc-platform/stores/WidgetEditStore.ts,

        let _st = WidgetEditStore._state; //   public _state: IWidgetEditState;
        //  or let _st = WidgetEditStore.getState();
        let widgetDataEdit = _st.widgetDataEdit; //  when Theme for Widget, null when for WS
        //    _st.widgetEditWorkspace = 1455   - when Theme for WS or Widget
        let widgetEditWorkspace = _st.widgetEditWorkspace; //LL 04.11.19  use only with widgetID
        let widgetID;

        if (widgetDataEdit != null) {
            //let widgetType = widgetDataEdit.type; // it is "pdc-widget-chart",  "pdc-widget-drill-down"
            widgetData = widgetDataEdit.values[widgetDataEdit.type]; //LL: 01.05.20: not used

            //LL: TRY, don't remove
            //if (widgetData != null) {
            //
            //    //LL: TRY, don't remove
            //    //   Suppose that no Containers in "pdc-widget-drill-down", so no recursion here
            //    //   But other containers can have, so recursion is needed
            //
            //    //if (widgetType === "pdc-widget-drill-down") {
            //    //    //LL:  for "pdc-widget-drill-down":
            //    //    //  widgetData.drillDown = { drillDown,  widgets: array of { type (="pdc-widget-chart"), values, id, cid } }
            //    //    //LL: but I cannot get which child is now edited !
            //    //
            //    //    let widgets = widgetData.drillDown.widgets;
            //    //
            //    //    //LL: 12.02.20:   new:  TRY   may be null => the 1st    //LL: *****
            //    //    //let curWidgetId = widgetData.drillDown.curWidgetId;
            //    //
            //    //    //LL: 13.02.20:  new another way: TRY   widget.selectedInEditor    //LL: +++++
            //    //    //LL:  it works good with proper changes in MultiWidgetField.tsx, marked with //LL: +++++
            //    //    //   BUT:  what if we are editing DrillDown ITSELF (its Theme) ??????  !!!!!
            //    //    //   SO, wrong way ?
            //    //    let curWidget: any;  // IWidget
            //    //
            //    //    if (widgets != null && widgets.length > 0) {
            //    //        curWidget = _.find(widgets,
            //    //            (widget) => {   // IWidget
            //    //                return widget.selectedInEditor === true;
            //    //            }
            //    //        );
            //    //
            //    //        if (curWidget == null) {
            //    //            curWidget = widgets[0];
            //    //        }
            //    //    }
            //    //
            //    //    if (curWidget != null) {
            //    //        //LL:  and use loop until not container
            //    //    }
            //    //}   // pdc-widget-drill-down  TRY
            //
            //}

            widgetID = widgetDataEdit.id; // .cid ?   //LL 04.11.19
        }

        //LL 04.11.19:
        const WorkspacetEditStore = this.props.glob.WorkspaceEditStore;
        //   WorkspacetEditStore._state.id  -  null when Application or Widget Edit,  id: 1455 when WS edit
        let workspaceID;

        if (WorkspacetEditStore._state != null && WorkspacetEditStore._state.id != null) {
            workspaceID = WorkspacetEditStore._state.id;
        }

        //LL 04.11.19:
        //let WorkspaceStore = glob.WorkspaceStore;
        //   WorkspaceStore._state.instances - list of WSs

        //LL: 06.06.18: for Fields with array values, ex. color mapping
        //LL:  getOptions in ParameterFieldBase.ts (platform)
        //        return _.extend(
        //            this.getDefaultOptions(),
        //            this.options
        //        );
        let EditComponentOptions: any = this.props.param.getOptions() || {};

        EditComponentOptions.optionThemeOwnAndParent = {
            ownValue: this.props.ownValue,
            parentValue: this.props.parentValue
        };

        //LL: 01.05.20: not used
        //LL: 06.09.19:  try to access Widget Props in Theme:  OLD
        //EditComponentOptions.widgetDataForTheme = widgetData;

        //LL 04.11.19:  try
        //LL:  multi-widget containers ??
        EditComponentOptions.widgetID = widgetID; //LL 04.11.19  long-long number  null for WS
        EditComponentOptions.widgetEditWorkspace = widgetEditWorkspace; //LL 04.11.19   1455, err: remains old (unchanged) when not Widget Edit
        EditComponentOptions.workspaceID = workspaceID; //LL 04.11.19  null when Application or Widget Edit,  id: 1455 when WS edit

        //LL: 08.03.20: to access Widget Props in Theme   NEW
        EditComponentOptions.widgetValues = this.props.widgetValues; //LL: 15.03.20 to access Widget Props in Theme (when from WidgetBase)
        EditComponentOptions.widgetTypeName = this.props.widgetTypeName;

        //LL: 19.09.19: try to access all Theme items in a Theme item:
        //  no  EditComponentOptions.finalTheme = this.props.finalTheme;  // or themeObj ?  YES:

        //LL: 23.09.19: try to access all Theme items in a Theme item:   OK, YES !
        //   another way:  add finalTheme as themeObj to props:
        //LL: see how in WidgetParametersEdit.tsx (pdc-platform):
        //   themeObj={ this.state.themeObj }   to <EditComponent

        return (
            <ParameterField
                key="parameter-field"
                param={this.props.param}
                options={this.props.param.getOptions() || {}}
                clearable={this.props.clearable}
                showInheritedIcon={this.props.showInheritedIcon}
                hidden={this.props.hidden}
                className={
                    'selectable' + (this.props.selected ? ' selected' : '') + (this.props.dependent ? ' dependent' : '')
                }
                onClick={this.props.onHeaderClick}
                onClear={this.props.onClear}
                glob={this.props.glob}
            >
                <this.props.EditComponent
                    key="parameter-filed-edit"
                    value={this.props.value}
                    param={this.props.param}
                    options={EditComponentOptions}
                    themeObj={this.props.finalTheme}
                    onChange={this.props.onChange}
                    glob={this.props.glob}
                />

                {deps}

                {inherited}
            </ParameterField>
        );
    }
}

interface IParamsHash {
    [id: string]: ParameterFieldBase<IParameterFieldBaseOptions>;
}

interface IThemeFieldComponentState {
    parentThemes;
    finalTheme;
    selectedVar: string;
    onlyBase: boolean;
    themeConfig: typeof appTheme.state;
    selectedSection: string;
    initialValue;
    sectionCollapsedDict: IToggleStates;
    levels: string[];
    params?: IParamsHash;
    widgetData?: any; //LL: 09.09.19:  try to access Widget Props in Theme   OLD
    widgetType?: string; //LL: 14.02.20:  try to access Widget Props in Theme  OLD
    widgetValues?: any; //LL: 15.03.20 to access Widget Props in Theme   NEW
    widgetTypeName?: string; //LL: 08.03.20:  to access Widget Props in Theme  NEW
    savedState?: any; //LL: 27.08.20
}

export class ThemeFieldComponent extends React.Component<
    {
        value;
        levels?: string[];
        widgetValues?: any; //LL: 15.03.20 to access Widget Props in Theme
        widgetTypeName?: string; //LL: 08.03.20 to access Widget Props in Theme  NEW
        parentThemes?;
        themeContext?;
        hidden?: boolean;

        options?: {
            levels?: string[];
            widgetValues?: any; //LL: 15.03.20 to access Widget Props in Theme
            widgetTypeName?: string; //LL: 08.03.20
            parentThemes?;
            themeNodeIdToExpand?: string;
            themeContext?;
            savedState?: any; //LL: 27.08.20
        };
        glob: IGlob;

        onChange(val, valid: boolean): void;
    },
    IThemeFieldComponentState
> {
    static defaultProps = {
        parentThemes: [],
        levels: ['application']
    };

    private references: {
        previewContainer?: HTMLDivElement;
        previewInnerContainer?: HTMLDivElement;
    } = {};

    //LL: 30.09.20: this.props.options.savedState is not stable, sometimes caller is recreated and savedState is lost
    //  Maybe try localStorage, using widgetValues.id ?    sessionStorage ?

    //private useLocalStorageFlag = false; //LL: my flag
    private useLocalStorageFlag = true; //LL: my flag

    //LL: 30.09.20: if useLocalStorageFlag
    private static localStorageKey = 'pdc-dashboard-ThemeField-savedState';

    create_localStorageKey = (widgetValues) => {
        const widgetID = widgetValues != null ? widgetValues.id : null;

        return ThemeFieldComponent.createLocalStorageKey(widgetID);
    };

    private static createLocalStorageKey(widgetID) {
        const widgetID_Str = widgetID == null ? '' : '_widgetID_' + widgetID.toString();

        return ThemeFieldComponent.localStorageKey + widgetID_Str;
    }

    //LL: 30.09.20: if useLocalStorageFlag   sessionStorage   Use in WidgetEdit.tsx
    public static clearThemeFieldState(widgetID) {
        if (window.sessionStorage != null) {
            let lsKey = ThemeFieldComponent.createLocalStorageKey(widgetID);
            window.sessionStorage.removeItem(lsKey);
        }
    }

    //LL: 30.09.20: if useLocalStorageFlag   sessionStorage
    get_savedStateFromLocalStorage = (widgetValues) => {
        let savedState;
        if (window.sessionStorage != null) {
            let lsKey = this.create_localStorageKey(widgetValues);
            let text = window.sessionStorage.getItem(lsKey);
            if (text != null && text !== 'undefined') {
                savedState = JSON.parse(text);
            }
        }
        return savedState;
    };

    //LL: 30.09.20: if useLocalStorageFlag   sessionStorage
    set_savedStateToLocalStorage = (widgetValues, savedState) => {
        if (window.sessionStorage != null) {
            let lsKey = this.create_localStorageKey(widgetValues);
            let text = JSON.stringify(savedState);
            window.sessionStorage.setItem(lsKey, text);
        }
    };

    constructor(props) {
        super(props);

        let firstSection = { id: 'widget' }; //appTheme.state.sections[0];

        if (this.props.options != undefined && this.props.options.themeNodeIdToExpand != undefined) {
            firstSection = { id: this.props.options.themeNodeIdToExpand };
        }

        const parentThemes = this.getParentThemes(this.props);

        //LL: 09.09.19: try to access Widget Props in Theme:  OLD
        let levels = (this.props.options && this.props.options.levels) || this.props.levels;
        let widgetData; //LL: 01.05.20: not used ??
        let widgetType; //LL: 01.05.20: not used ??
        let widgetValues; //LL: 15.03.20  to access Widget Props in Theme   NEW
        let widgetTypeName; //LL: 08.03.20 NEW

        if (levels != null && levels.length > 0) {
            if (levels[0] === 'widget') {
                let ooo = this.getWidgetProps(); // return { widgetData: widgetData, widgetType: widgetType };  // "pdc-widget-chart"

                widgetData = ooo.widgetData; //LL: 01.05.20: not used ??
                widgetType = ooo.widgetType; // "pdc-widget-chart"   //LL: 01.05.20: not used ??

                //LL: 15.03.20 to access Widget Props in Theme   from ThemesListField.tsx:  widgetValues={ this.state.widgetValues }
                widgetValues =
                    this.props.options != null && this.props.options.widgetValues != null
                        ? this.props.options.widgetValues
                        : this.props.widgetValues;
                widgetTypeName =
                    this.props.options != null && this.props.options.widgetTypeName != null
                        ? this.props.options.widgetTypeName
                        : this.props.widgetTypeName;
            }

            if (levels[0] === 'workspace') {
                firstSection = { id: 'workspace' };
            }
        }

        //LL: 30.09.20: this.props.options.savedState is not stable, sometimes caller is recreated and savedState is lost
        //  Maybe try localStorage/sessionStorage, using widgetValues.id ?
        //
        //LL: 27.08.20: selected and collapsed are created from scratch, old state is not applied (ThemeField created in ThemesListField)
        //    So try "controlled" component: save selected and collapsed externaly
        let selectedSection = firstSection && firstSection.id;
        let collapsedSections = {};
        let savedState: any; //LL: 30.09.20: from options (saved by caller) or from localStorage/sessionStorage - by useLocalStorageFlag

        if (!this.useLocalStorageFlag) {
            if (this.props.options != null && this.props.options.savedState != null) {
                savedState = this.props.options.savedState;
            }
        }

        //LL: 30.09.20:
        if (this.useLocalStorageFlag) {
            let ss = this.get_savedStateFromLocalStorage(widgetValues);
            if (ss != null && ss.savedState != null) {
                savedState = ss;
            } else {
                savedState = { savedState: {} };
            }
        }

        if (savedState != null) {
            if (savedState.savedState != null) {
                // take initial selected and collapsed from it
                if (savedState.savedState.selectedSection != null) {
                    selectedSection = savedState.savedState.selectedSection;
                }
                if (savedState.savedState.collapsedSections != null) {
                    collapsedSections = savedState.savedState.collapsedSections;
                }
            }
        }

        let stateObj: IThemeFieldComponentState = {
            themeConfig: appTheme.state,
            selectedSection: selectedSection, //LL: 27.08.20
            selectedVar: null,
            sectionCollapsedDict: collapsedSections, //LL: 27.08.20
            savedState: savedState, //LL: 27.08.20
            parentThemes: parentThemes,
            initialValue: _.clone(this.props.value),
            finalTheme: this.getFinalTheme(parentThemes, this.props.value),
            onlyBase: false,
            widgetData: widgetData, //LL: 09.09.19: try to access Widget Props in Theme   OLD
            widgetType: widgetType, //LL: 14.02.20: try to access Widget Props in Theme   OLD
            widgetValues: widgetValues, //LL: 15.03.20  to access Widget Props in Theme   NEW
            widgetTypeName: widgetTypeName, //LL: 08.03.20:  to access widget props in Theme    NEW
            levels: levels
        };

        //LL: 30.09.20: Maybe remove all code about Collapsed, because now savedState is used. Or when 1st call ? Or is not in savedState
        //  And anyway, must be return "false"
        const params = _.reduce<appTheme.IVariable[], IParamsHash>(
            appTheme.state.vars,
            (res, _obj) => {
                res[_obj.id] = _obj.param;

                //LL: 30.09.20: note:
                // For vars which values are set or which are defined in Parent Theme (widget -> workspace -> application)
                // Their Parent Sections were set expanded - until OE change below: "stateObj.sectionCollapsedDict[parent] = true;"
                // So now they are collapsed.
                if ((this.props.value[_obj.id] != null || parentThemes[_obj.id] != null) && _obj.section != null) {
                    let parent = _obj.section;

                    while (
                        (parent = appTheme.state.sectionsDict[parent] && appTheme.state.sectionsDict[parent].parent)
                    ) {
                        //stateObj.sectionCollapsedDict[parent] = true; //LL: 30.09.20: commented, try
                        //LL: 30.09.20: note: in above code "false" was changed to "true" by OE 13.06.17 ver 24 in Vault
                        //   Don't know why.  Initial code by Taras was "false", i.e. Parents were expanded
                    }
                }

                return res;
            },
            {}
        );

        stateObj.params = params;
        stateObj.sectionCollapsedDict['widget'] = false;

        //LL: 10.11.19: "selectedSection: firstSection && firstSection.id,"   MUST BE EXPANDED with all its parents
        //LL:   firstSection is themeNodeIdToExpand
        //LL:   (Leo asks to expand "Charts",  I think the same is for, e.g., Gauge
        if (firstSection.id != 'widget') {
            //LL: expand all parents for themeNodeIdToExpand:
            let sectionId = firstSection.id;

            do {
                stateObj.sectionCollapsedDict[sectionId] = false;

                if (appTheme.state.sectionsDict[sectionId] == null) {
                    break;
                }

                sectionId = appTheme.state.sectionsDict[sectionId].parent;
            } while (sectionId != null && sectionId != 'widget');
        }

        this.state = stateObj;
    }

    getParentThemes = (props) => {
        let parentThemes = appTheme.extend.apply(_, [{}].concat(props.parentThemes));

        parentThemes = appTheme.extend({}, props.options && props.options.parentTheme, parentThemes);

        return parentThemes;
    };

    getFinalTheme = (parentThemes, value) => {
        return appTheme.getThemeObj(appTheme.extend.apply(_, [{}].concat(parentThemes).concat(value)));
    };

    componentWillReceiveProps(nextProps) {
        if (!compareObjects(nextProps.parentThemes, this.props.parentThemes)) {
            const parentThemes = this.getParentThemes(nextProps);

            this.setState({
                parentThemes: parentThemes,
                finalTheme: this.getFinalTheme(parentThemes, nextProps.value)
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const previewInnerContainer = this.references.previewInnerContainer;
        const previewElement = document.getElementById('preview_' + this.state.selectedSection);

        if (previewInnerContainer != null) {
            const previewContainer = this.references.previewContainer;

            let win_height = '398px';

            if (previewContainer) {
                win_height = previewContainer.offsetHeight - previewContainer.offsetTop + 'px';
            }

            $(previewInnerContainer).css('height', win_height);

            if (previewElement != null /*&& prevState.selectedSection !== this.state.selectedSection*/) {
                $(previewInnerContainer).scrollTop(previewElement.offsetTop);
            }
        }
    }

    processOnChange(value) {
        if (typeof this.props.onChange === 'function') {
            let valid = true;

            for (let id in this.state.params) {
                const param = this.state.params[id];

                if (param != null && param.brokenValidators != null && param.brokenValidators.length > 0) {
                    valid = false;
                    break;
                }
            }

            this.props.onChange(value, valid);
        }
    }

    getChangeHandler(param: ParameterFieldBase<IParameterFieldBaseOptions>, id: string) {
        return (value) => {
            param.validate(value);

            let obj = _.clone(this.props.value);

            //LL: 08.06.18:
            if (value == null) {
                delete obj[id];
            } else {
                obj[id] = value;
            }

            let inheritedValues = appTheme.calcInherited(id, value, appTheme.extend({}, this.state.parentThemes, obj));

            this.setState({
                finalTheme: _.extend({}, this.state.finalTheme, inheritedValues)
            });

            this.processOnChange(obj);
        };
    }

    getOnClearFieldHandler(id: string) {
        return () => {
            const obj = _.clone(this.props.value);

            delete obj[id];

            const inheritedValues = appTheme.calcInherited(id, null, appTheme.extend({}, this.state.parentThemes, obj));
            const param = this.state.params[id];

            param.validate(inheritedValues[id]);

            this.setState({
                finalTheme: appTheme.extend(this.state.finalTheme, inheritedValues)
            });

            this.processOnChange(obj);
        };
    }

    getOnVariableHeaderClickHandler(id: string) {
        return () => {
            let selectedVar;

            if (id === this.state.selectedVar) {
                selectedVar = null;
            } else {
                selectedVar = id;
            }

            this.setState({ selectedVar: selectedVar });
        };
    }

    getVarClick = (obj) => {
        return (e) => {
            const state = {
                selectedVar: obj.id,
                selectedSection: obj.section,
                sectionCollapsedDict: this.state.sectionCollapsedDict
            };

            const sectionsDict = this.state.themeConfig.sectionsDict;

            let parent = obj.section;

            while ((parent = sectionsDict[parent] && sectionsDict[parent].parent)) {
                state.sectionCollapsedDict[parent] = false;
            }

            this.setState(state);

            e.stopPropagation();
            e.preventDefault();
        };
    };

    getVars = (arr: string[]) => {
        if (arr == null) {
            return;
        }

        return _.map(arr, (id) => {
            const obj = appTheme.state.varsDict[id];
            if (obj == null) {
                return;
            }

            return (
                <span key={id} className="label label-default var-link-element" onClick={this.getVarClick(obj)}>
                    {obj.param && obj.param.title}
                </span>
            );
        });
    };

    getField = (obj) => {
        this._fieldInluded.push(obj.id);

        const param = this.state.params[obj.id];
        const EditComponent = (param.constructor as any).EditComponent;
        const ownValue = this.props.value[obj.id];
        const parentValue = this.state.parentThemes[obj.id];
        const value = this.state.finalTheme[obj.id];

        //LL: 24.04.20:    prohibitClearable: true,  for arrays, AxisArrays
        //LL:  maybe also for all that has isArray: true ?
        let isArray = obj.isArray != null ? obj.isArray : false;

        let clearable = ownValue != null;
        if (obj.prohibitClearable === true) {
            clearable = false;
        }
        if (isArray && obj.prohibitClearable == null) {
            clearable = false;
        }

        let showInheritedIcon = !clearable && parentValue != null;
        if (obj.prohibitInheritedIcon === true) {
            showInheritedIcon = false;
        }
        if (isArray && obj.prohibitInheritedIcon == null) {
            showInheritedIcon = false;
        }

        param.validate(value); //EVG: Revalidate component with the new value to drop previous validation results.

        let dependationVariables;
        let inheritedVariables;

        if (obj.id === this.state.selectedVar) {
            dependationVariables = this.getVars(obj.deps);
            inheritedVariables = this.getVars(obj.inherit);
        }

        let onChangeHandler;

        const dependent = obj.deps != null && obj.deps.length > 0;

        if (!this.state.onlyBase || !dependent) {
            onChangeHandler = this.getChangeHandler(param, obj.id);
        }

        //LL: 06.09.19:  try to access Widget Props in Theme:   OLD
        //  <ParameterField.tsx  has prop  hidden?: boolean;   !!!
        //  hidden={ this.props.hidden }

        //LL: 19.09.19: try to access all Theme items in a Theme item:
        //    add  finalTheme={ this.state.finalTheme }

        //  widgetValues: widgetValues, //LL: 15.03.20 to access Widget Props in Theme   NEW

        let field = (
            <EditComponentDepsWrapper
                key={obj.id}
                EditComponent={EditComponent}
                param={param}
                clearable={clearable}
                showInheritedIcon={showInheritedIcon}
                hidden={this.props.hidden}
                selected={obj.id === this.state.selectedVar}
                dependent={dependent}
                value={value}
                ownValue={ownValue}
                parentValue={parentValue}
                finalTheme={this.state.finalTheme}
                widgetValues={this.state.widgetValues}
                widgetTypeName={this.state.widgetTypeName}
                dependationVariables={dependationVariables}
                inheritedVariables={inheritedVariables}
                onChange={onChangeHandler}
                onClear={this.getOnClearFieldHandler(obj.id)}
                onHeaderClick={this.getOnVariableHeaderClickHandler(obj.id)}
                glob={this.props.glob}
            />
        );

        return field;
    };

    //LL: 01.05.20:  outdated ??
    //LL: 09.09.19: try to access Widget Props in Theme:   OLD
    getWidgetProps = () => {
        // this.props.glob.WidgetEditStore._state.widgetDataEdit:
        //       cid, id, theme, type = "pdc-widget-chart', values.pdc-widget-chart - they are props !!
        //    WidgetEditStore.getState ?  Yes, BaseStore has getState(): return this._state;

        let widgetData;
        let widgetType;
        let glob = this.props.glob;
        let WidgetEditStore = glob.WidgetEditStore; //   pdc-platform/stores/WidgetEditStore.ts,
        let _st = WidgetEditStore._state; //   public _state: IWidgetEditState;
        //  or let _st = WidgetEditStore.getState();
        let widgetDataEdit = _st.widgetDataEdit; //  when Theme for Widget, null when for WS
        //    _st.widgetEditWorkspace = 1455   - when Theme for WS or Widget

        //LL: also can check levels =[ "widget", "pdc-widget-chart" ]
        if (widgetDataEdit != null) {
            widgetType = widgetDataEdit.type; // "pdc-widget-chart"
            widgetData = widgetDataEdit.values[widgetDataEdit.type];
            if (widgetData != null) {
                //
            }
        }

        return { widgetData: widgetData, widgetType: widgetType }; // "pdc-widget-chart"
    };

    //LL: 09.09.19: try
    // consider level, widgetParams, other Theme fields
    isVarHidden = (obj) => {
        if (obj.hidden == null) {
            return false;
        }

        if (typeof obj.hidden === 'boolean') {
            return obj.hidden === true;
        }

        if (typeof obj.hidden === 'function') {
            // consider level, widgetParams, other Theme fields (this.props.value, finalTheme ?)

            //LL: 14.02.20: try to access Widget Props in Theme   OLD
            //return obj.hidden(this.state.levels, this.state.widgetData, this.state.widgetType);

            //LL: 15.03.20 to access Widget Props in Theme   NEW
            return obj.hidden(this.state.levels, this.state.widgetValues, this.state.widgetTypeName);
        }
    };

    private _fieldInluded = [];

    getFields() {
        this._fieldInluded = [];

        return _.chain(this.state.themeConfig.vars)
            .filter((obj) => {
                return obj.section === this.state.selectedSection;
            })
            .map((obj) => {
                //LL: 09.09.19: try,
                //   if function: consider level, widgetParams, other Theme fields
                if (this.isVarHidden(obj)) {
                    return null;
                }

                if (!_.contains(this._fieldInluded, obj.id)) {
                    if (obj.group == null) {
                        return this.getField(obj);
                    } else {
                        return this.getGroup(obj.group);
                    }
                }
            })
            .value();
    }

    getGroup(groupId) {
        let fields = _.chain(this.state.themeConfig.vars)
            .filter((obj) => {
                return obj.group === groupId;
            })
            //.map(this.getField)
            //LL: 09.09.19: try:
            .map((obj) => {
                //LL: 09.09.19: try,
                //   if function: consider level, widgetParams, other Theme fields
                if (this.isVarHidden(obj)) {
                    return null;
                }

                return this.getField(obj);
            })

            .value();

        let groupName = this.state.themeConfig.groupsDict[groupId].name;

        //LL: 19.02.20:
        let explanation = this.state.themeConfig.groupsDict[groupId].explanation;
        let explanationElem;

        if (explanation != null) {
            explanationElem = (
                <div key={'explanation'} className="explanation">
                    {explanation}
                </div>
            );
        }

        return (
            <div className="card mb-1" key={'group-' + groupId}>
                <div className="card-header">{groupName}</div>
                <div className="card-body p-2">
                    {explanationElem}
                    {fields}
                </div>
            </div>
        );
    }

    handleSectionSelect = (value) => {
        //LL: 27.08.20
        let savedState = this.state.savedState;

        if (savedState != null) {
            //savedState.selectedSection = value;
            if (savedState.savedState != null) {
                savedState.savedState.selectedSection = value;
            }
        }

        //LL: 30.09.20:
        if (this.useLocalStorageFlag) {
            this.set_savedStateToLocalStorage(this.state.widgetValues, savedState);
        }

        this.setState({ selectedSection: value });
    };

    handleOnSectionCollapsedChange = (id: string, collapsed: boolean) => {
        const sectionCollapsedDict = $.extend(true, {}, this.state.sectionCollapsedDict);
        sectionCollapsedDict[id] = collapsed;

        //LL: 27.08.20
        let savedState = this.state.savedState;
        if (savedState != null) {
            const sectionCollapsedDict2 = $.extend(true, {}, sectionCollapsedDict);
            //savedState.collapsedSections = sectionCollapsedDict2;
            if (savedState.savedState != null) {
                savedState.savedState.collapsedSections = sectionCollapsedDict2;
            }
        }

        //LL: 30.09.20:
        if (this.useLocalStorageFlag) {
            this.set_savedStateToLocalStorage(this.state.widgetValues, savedState);
        }

        this.setState({ sectionCollapsedDict: sectionCollapsedDict });
    };

    //LL: 20.08.20:
    var_hasBrokenValidators = (varObj: any) => {
        let param = varObj.param;
        let broken = param != null && param.brokenValidators != null && param.brokenValidators.length > 0;
        //if (broken) {
        //    console.log("broken: " + varObj.id + ", " + (param != null ? param.title : "") );
        //}
        return broken;
    };

    //LL: 20.08.20:
    section_getBrokenValidators = (sectionObj: any) => {
        let invalid = _.filter(sectionObj.vars, (obj: any) => {
            let broken = this.var_hasBrokenValidators(obj);
            return broken;
        });
        return invalid;
    };

    //LL: 20.08.20: recoursive
    section_hasProblemChildren = (sectionObj: any) => {
        let invalidChildren = _.filter(sectionObj.children, (childSection: any) => {
            //let name = childSection.name;
            //  own BrokenValidators:
            let brokenValidators = this.section_getBrokenValidators(childSection); // array
            let broken = brokenValidators.length > 0;

            if (!broken) {
                // find child-Section with BrokenValidators
                let sectObj = childSection;
                if (sectObj.children.length > 0) {
                    let hasProblem = this.section_hasProblemChildren(sectObj);
                    if (hasProblem) {
                        broken = true;
                    }
                }
            }

            return broken;
        });

        return invalidChildren.length > 0;
    };

    getSectionName = (themeObj, name: string) => {
        if (themeObj == null) {
            return name;
        }
        //if (themeObj.vars == null) { return name; }

        //LL: 20.08.20:
        if (themeObj.vars == null && (themeObj.children == null || themeObj.children.length === 0)) {
            return name;
        }
        let hasVars = themeObj.vars != null;

        //LL: 20.08.20:
        let invalid = hasVars ? this.section_getBrokenValidators(themeObj) : []; // array

        //LL: 20.08.20: children are sections
        //  They can have own BrokenValidators and own child-Section with BrokenValidators
        let hasProblemChildren = this.section_hasProblemChildren(themeObj);

        let edit = [];
        let edit_isObject = []; //LL: 02.10.20
        let edit_isObject_Sum = 0; //LL: 02.10.20

        if (hasVars) {
            edit = _.filter(themeObj.vars, (obj: any) => {
                let isArray = obj.isArray === true;
                let isObject = obj.isObject === true; //LL: 03.08.20

                if (isObject) {
                    //  own value:
                    let val = this.props.value[obj.id];
                    if (val != null) {
                        //console.log("--------isObject getSectionName val != null " + obj.id);
                    }
                    //   this.props.options.parentTheme
                    let valParent;
                    let opt: any = this.props.options;

                    if (opt != null) {
                        let pt = opt.parentTheme; //EVG: Is it used?

                        if (pt != null) {
                            valParent = pt[obj.id];
                        }
                    }

                    const param = obj.param;
                    const EditComponent = (param.constructor as any).EditComponent;
                    if (EditComponent != null) {
                        //LL: now only for Axis: X,Y,Arr
                        if (
                            EditComponent.numberOfEditedItems != null &&
                            typeof EditComponent.numberOfEditedItems === 'function'
                        ) {
                            let editedItems = EditComponent.numberOfEditedItems(val, valParent);
                            //LL: set anyway:
                            //if (editedItems !== 0) {
                            edit_isObject.push({
                                id: obj.id,
                                num: editedItems
                            });
                            edit_isObject_Sum += editedItems;
                            //}
                        }
                    }
                }

                if (isArray) {
                    let val = this.props.value[obj.id];

                    return val != null && val.length > 0;
                } else {
                    const defaultValue = obj.param.getDefault(this.state.finalTheme);

                    return (
                        this.props.value[obj.id] != null &&
                        defaultValue != undefined &&
                        !obj.param.isEqual(this.props.value[obj.id], defaultValue)
                    );
                }
            });
        }

        let inherit = [];
        if (hasVars) {
            inherit = _.filter(themeObj.vars, (obj: any) => {
                //LL: 23.04.19:  isArray?: boolean;  in interface IVariable (appTheme.ts)
                let isArray = obj.isArray === true;
                let isObject = obj.isObject === true; //LL: 03.08.20
                if (isArray) {
                    let parentVal = this.state.parentThemes[obj.id];
                    let val = this.props.value[obj.id];
                    return parentVal != null && parentVal.length > 0 && (val == null || val.length === 0);
                } else {
                    return this.state.parentThemes[obj.id] != null && this.props.value[obj.id] == null;
                }
            });
        }

        let arr = [<span key="name">{name}</span>];

        if (edit.length !== 0) {
            //LL: was:
            //arr = arr.concat(
            //    [
            //        <span key={ "edit" } className="vars-value">{ edit.length }</span>,
            //        <span key={ "edit-icon" } className="glyphicon glyphicon-pencil"></span>
            //    ]
            //);

            //LL: 02.10.20:  edit_isObject = [],   edit_isObject_Sum
            //LL: now only for Axis: X,Y,Arr

            //LL: 1st variant:   new items(sub-items):  don't think it is very good
            //let editedObjectItems = "";
            //if (edit_isObject_Sum > 0) {
            //    editedObjectItems = "(" + edit_isObject_Sum + ")";
            //}
            //arr = arr.concat(
            //    [
            //        <span key={ "edit" } className="vars-value">{ edit.length + editedObjectItems }</span>,
            //        <span key={ "edit-icon" } className="glyphicon glyphicon-pencil"></span>
            //    ]
            //);

            //LL: 2nd variant:
            let N = edit.length;
            _.each(edit, function (obj: any, index) {
                let A = _.find(edit_isObject, function (a) {
                    return a.id == obj.id;
                });
                if (A != null) {
                    N -= 1;
                    N += A.num;
                }
            });
            if (N > 0) {
                arr = arr.concat([
                    <span key={'edit'} className="vars-value">
                        {N}
                    </span>,
                    <span key={'edit-icon'} className="glyphicon glyphicon-pencil"></span>
                ]);
            }
        }

        if (inherit.length !== 0) {
            arr = arr.concat([
                <span key={'inherit'} className="vars-value">
                    {inherit.length}
                </span>,
                <span key={'inherit-icon'} className="glyphicon glyphicon-arrow-down"></span>
            ]);
        }

        //LL: 19.08.20:
        if (invalid.length !== 0) {
            let style1: any = {
                color: 'red'
            };
            arr = arr.concat([
                <span key={'invalid'} className="vars-value" style={style1}>
                    {invalid.length}
                </span>,
                <span key={'invalid-icon'} className="glyphicon glyphicon-warning-sign" style={style1}></span>
            ]);
        }

        //LL: 20.08.20: children are sections
        if (hasProblemChildren) {
            let style1: any = {
                color: 'red',
                marginLeft: '5px'
            };
            arr = arr.concat([
                <span
                    key={'invalidChildren-icon'}
                    className="glyphicon glyphicon-exclamation-sign"
                    style={style1}
                    title="problems in child sections"
                ></span>
            ]);
        }

        return arr;
    };

    sectionsDisplayFilter = (obj) => {
        if (obj.visibility != null) {
            return _.intersection(obj.visibility, this.state.levels).length > 0;
        }

        return true;
    };

    sectionsHiddenFilter = (obj) => {
        // returns true to hide
        if (obj.hiddenOptions != null) {
            if (obj.hiddenOptions.hiddenFunction != null) {
                if (typeof obj.hiddenOptions.hiddenFunction === 'function') {
                    // consider level, widgetParams, other Theme fields (this.props.value, finalTheme ?)

                    //LL: 14.02.20: try to access Widget Props in Theme    OLD
                    //return obj.hiddenOptions.hiddenFunction(this.state.levels, this.state.widgetData, this.state.widgetType);

                    //LL: 15.03.20 to access Widget Props in Theme   NEW
                    return obj.hiddenOptions.hiddenFunction(
                        this.state.levels,
                        this.state.widgetValues,
                        this.state.widgetTypeName
                    );
                }
            }
        }

        return false;
    };

    getPath = (id) => {
        let obj;
        let cur = id;
        let res = [];

        while (cur != null && (obj = this.state.themeConfig.sectionsDict[cur]) != null) {
            res.unshift(obj);
            cur = obj.parent;
        }

        return res;
    };

    breadcrumbNavigate = (id) => {
        let _self = this;
        return function (e) {
            _self.handleSectionSelect(id);
        };
    };

    getBreadcrumbs = () => {
        if (this.state.selectedSection == null) {
            return;
        }

        let path = this.getPath(this.state.selectedSection);

        let items = _.map(path, (obj) => {
            return (
                <li key={obj.id} className="breadcrumb-item" onClick={this.breadcrumbNavigate(obj.id)}>
                    <span>{obj.name}</span>
                </li>
            );
        });

        //LL: 06.02.18:  "breadcrumb" margin-bottom: 15px
        let explanation = this.getSelectedExplanation();
        let style1: React.CSSProperties = {};

        if (explanation != null) {
            style1.marginBottom = '8px';
        }

        return (
            <ol key="ol" className="breadcrumb" style={style1}>
                {items}
            </ol>
        );
    };

    //LL: 06.02.18:
    getExplanation = () => {
        let explanation = this.getSelectedExplanation();
        if (explanation == null) {
            return;
        }

        return (
            <span key={'explanation'} className="explanation">
                {explanation}
            </span>
        );
    };

    //LL: 06.02.18:
    getSelectedExplanation = () => {
        if (this.state.selectedSection == null) {
            return;
        }

        const section = this.state.themeConfig.sectionsDict[this.state.selectedSection];
        if (section == null) {
            return;
        }

        return section.explanation; //  can be null
    };

    getSections = () => {
        //LL: 10.09.19: add hiddenFilter, change in arr
        return (
            <TreeItemGeneral
                key="_root"
                id="_root"
                name="/"
                arr={_.filter(this.state.themeConfig.sections, (obj: any) => {
                    //return obj.parent == null;  //LL: was
                    //return (obj.parent == null && obj.hidden !== true); //LL: 10.09.19: try
                    return obj.parent == null && this.sectionsHiddenFilter(obj) !== true; //LL: 10.09.19: try
                })}
                select={this.state.selectedSection}
                collapsed={false}
                collapsedDict={this.state.sectionCollapsedDict}
                shadow={true}
                onSelect={this.handleSectionSelect}
                onCollapsedChange={this.handleOnSectionCollapsedChange}
                nameFunc={this.getSectionName}
                displayFilter={this.sectionsDisplayFilter}
                hiddenFilter={this.sectionsHiddenFilter}
            />
        );
    };

    getPreview = () => {
        if (this.state.selectedSection == null) {
            return;
        }

        let section = this.state.themeConfig.sectionsDict[this.state.selectedSection];

        if (section == null || section.preview == null) {
            return;
        }

        let finalTheme = _.clone(this.state.finalTheme);

        let context = '';

        if (this.props.options != null && this.props.options.themeContext != null) {
            context += this.props.options.themeContext + ' ';
        }

        context += '.section-preview';

        let sectionPreview;

        // first varian for __esModule theme preview. second for normal imported modules
        if (typeof section.preview.ThemePreview === 'function') {
            sectionPreview = section.preview.ThemePreview(this.props.glob, finalTheme);
        } else {
            sectionPreview = section.preview(this.props.glob, finalTheme);
        }

        let levels = _.clone(section.visibility);

        if (levels == null) {
            levels = [];
        }

        levels.push('application');
        levels.push('workspace');
        levels.push('widget');
        levels = _.uniq(levels);

        const sectionPreviewStyle: React.CSSProperties = {
            color: finalTheme['text-color'],
            backgroundColor: finalTheme['surface-bg'],
            fontFamily: finalTheme['#font-main'],
            borderColor: finalTheme['gray-light']
        };

        if (finalTheme['font-main-size'] !== 'default') {
            sectionPreviewStyle.fontSize = finalTheme['font-main-size'];
        }

        if (finalTheme['font-main-weight'] != null) {
            sectionPreviewStyle.fontWeight = finalTheme['font-main-weight'];
        }

        if (finalTheme['font-main-italic'] === true) {
            sectionPreviewStyle.fontStyle = 'italic';
        }

        return (
            <div
                style={{
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    right: '10px',
                    bottom: '30px'
                }}
                ref={(value) => {
                    this.references.previewContainer = value;
                }}
            >
                <div
                    className="section-preview-title"
                    style={{
                        background: finalTheme['gray-light'],
                        color: finalTheme['surface-bg']
                    }}
                >
                    {'Preview'}
                </div>

                <div
                    ref={(value) => {
                        this.references.previewInnerContainer = value;
                    }}
                    className={'section-preview' + (section.previewClassName && ' ' + section.previewClassName)}
                    style={sectionPreviewStyle}
                >
                    <ThemeRenderer key={'theme-renderer'} theme={finalTheme} levels={levels} context={context} />

                    {sectionPreview}
                </div>
            </div>
        );
    };

    handleOnBaseFlagChange = (value: boolean) => {
        this.setState({
            onlyBase: value
        });
    };

    resetTheme = (e) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange({}, true);
        }

        const parentThemes = this.getParentThemes(this.props);

        this.setState({
            finalTheme: this.getFinalTheme(parentThemes, {})
        });
    };

    restoreTheme = (e) => {
        const value = _.clone(this.state.initialValue);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, true);
        }

        const parentThemes = this.getParentThemes(this.props);

        this.setState({
            finalTheme: this.getFinalTheme(parentThemes, value)
        });
    };

    render() {
        let preview = this.getPreview();

        let previewBlock;

        if (preview != null) {
            previewBlock = (
                <div key="preview-block" className="col-sm-8">
                    {this.getPreview()}
                </div>
            );
        }

        //LL: 05.04.20:
        //  For Charts Right Pane is too narrow.  Also for Mappings better to widen Right Pane
        //  Or make width of Panes changable
        //LL: was 4 and 8   <div className="col-sm-4">
        //let leftPaneClass = "col-sm-4";
        //let rightPaneClass = "col-sm-8";
        let leftPaneClass = 'col-sm-3';
        let rightPaneClass = 'col-sm-9';

        return (
            <div
                key="theme-field"
                className={
                    'theme-field themes-list-select widget-parameters-edit' +
                    (this.state.onlyBase ? ' only-base-vars' : '')
                }
            >
                <div className="row">
                    <div className={leftPaneClass}>
                        <div className="action-buttons-container">
                            <div className="btn btn-xs btn-default reset-button" onClick={this.resetTheme}>
                                {'Clear All'}
                            </div>

                            <div className="btn btn-xs btn-default restore-button" onClick={this.restoreTheme}>
                                {'Restore Initial'}
                            </div>
                        </div>

                        <div className="only-base-switch">
                            <BooleanField
                                value={this.state.onlyBase === true}
                                allowNull={false}
                                title={'Hide Dependent Options'}
                                onChange={this.handleOnBaseFlagChange}
                            />
                        </div>

                        {this.getSections()}
                    </div>

                    <div className={rightPaneClass}>
                        {this.getBreadcrumbs()}

                        {this.getExplanation()}

                        <div key="section" className="row" style={{ height: '100%' }}>
                            <div key="section-fields" className={preview != null ? 'col-sm-4' : 'col-sm-12'}>
                                {this.getFields()}
                            </div>
                            {previewBlock}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export class ThemeField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [appTheme.themesValidator];

    public static EditComponent = ThemeFieldComponent;

    constructor(glob: IGlob, title: string, validators?: any, defaultVal: any = {}, options?) {
        super(glob, title, ThemeField.defaultValidators, validators, defaultVal, options);
    }
}
